import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HelpIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 21.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM12.668 3C16.543 3 19 5.444 19 9.104c0 2.912-2.243 4.88-5.786 6.177l-.214.075v.68a1 1 0 01-.883.993l-.117.007a1 1 0 01-.993-.884L11 16.036v-1.398a1 1 0 01.698-.953C15.012 12.636 17 11.09 17 9.104 17 6.55 15.44 5 12.668 5c-2.127 0-3.49.942-4.634 2.893a1 1 0 01-1.725-1.012C7.786 4.364 9.758 3 12.668 3z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
HelpIcon.isCarinaIcon = true;
export default HelpIcon;
